import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class CustomerService extends GenericService {
    constructor() {
        super('/customers', axiosInstance);
    }

    async getCostedOrders(customerId) {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/${this.encodePathSegment(customerId)}/costed_orders`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async pushCloud(customerId, payload = {}) {
        try {
            const response = await axiosInstance.post(
                `${this.baseUrl}/${this.encodePathSegment(customerId)}/cloud/push`,
                payload
            );
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }
}

export default new CustomerService(); 